import { render, staticRenderFns } from "./reduce.vue?vue&type=template&id=1f9947b5&scoped=true&"
import script from "./reduce.vue?vue&type=script&lang=js&"
export * from "./reduce.vue?vue&type=script&lang=js&"
import style0 from "./reduce.vue?vue&type=style&index=0&id=1f9947b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9947b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9947b5')) {
      api.createRecord('1f9947b5', component.options)
    } else {
      api.reload('1f9947b5', component.options)
    }
    module.hot.accept("./reduce.vue?vue&type=template&id=1f9947b5&scoped=true&", function () {
      api.rerender('1f9947b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deposit/components/deposit/reduce.vue"
export default component.exports